export interface EarthMaterialsAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/discovery-lab/earth-materials-yard';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): EarthMaterialsAsset => ({ key, path: `${ROOT}/${path}`, width, height, alpha, required: true });

export const EARTH_MATERIALS_ASSETS = {
  dormant: image(
    'earth-materials-dormant',
    'backgrounds/earth-materials-yard-dormant.png',
    1280,
    720,
    false,
  ),
  restored: image(
    'earth-materials-restored',
    'backgrounds/earth-materials-yard-restored.png',
    1280,
    720,
    false,
  ),
  card: image('earth-materials-card', 'interactives/earth-materials-card.png', 640, 480, true),
} as const;

export const EARTH_MATERIALS_ASSET_LIST = Object.values(EARTH_MATERIALS_ASSETS);
// Browser/PWA runtime QA is required before opening this route to players.
export const EARTH_MATERIALS_PRODUCTION_READY = true;

export function preloadEarthMaterialsAssets(scene: Phaser.Scene): void {
  EARTH_MATERIALS_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingEarthMaterialsAssets(
  textures: Phaser.Textures.TextureManager,
): EarthMaterialsAsset[] {
  return EARTH_MATERIALS_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterEarthMaterialsYard(textures: Phaser.Textures.TextureManager): boolean {
  return EARTH_MATERIALS_PRODUCTION_READY
    && getMissingEarthMaterialsAssets(textures).length === 0;
}
